export default [
  {
    path: '/eligibilities',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'eligibilities-check' */ '@/views/eligibilities/Check.vue')
  }
]
